export const createCustomFilterView = (activeFilterView, appliedFilters) => {
  return {
    gridConfigTypeId: activeFilterView.gridConfigTypeId,
    gridViewId: activeFilterView.gridViewId,
    filterViewId: 'custom',
    appliedFilters,
  };
};

const defaultFilterView = {
  filterViewId: 'default',
  appliedFilters: [],
};

export const getDefaultFilterView = () => {
  return defaultFilterView;
};

export const updateCustomViewProp = (propName, propValue, customView) => {
  return {
    ...customView,
    [propName]: propValue,
  };
};

export const replaceUpdatedFilterView = (propName, propValue, filterViewId, savedFilterViews) => {
  const index = savedFilterViews.findIndex((view) => view.filterViewId === filterViewId);
  if (index === -1) {
    return [...savedFilterViews];
  }

  const filterView = savedFilterViews.find((view) => view.filterViewId === filterViewId);
  const updatedFilterView = {
    ...filterView,
    [propName]: propValue,
  };
  return [...savedFilterViews.slice(0, index), updatedFilterView, ...savedFilterViews.slice(index + 1)];
};
